/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Requires_NotesInputs */

const en_task_flow_requires_notes = /** @type {(inputs: Task_Flow_Requires_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requires a note`)
};

const pt_br2_task_flow_requires_notes = /** @type {(inputs: Task_Flow_Requires_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exige observação`)
};

/**
* | output |
* | --- |
* | "Requires a note" |
*
* @param {Task_Flow_Requires_NotesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_requires_notes = /** @type {((inputs?: Task_Flow_Requires_NotesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Requires_NotesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_requires_notes(inputs)
	return pt_br2_task_flow_requires_notes(inputs)
});